import { MaskedFieldManagerBase } from '@cof/fs-masked-field-manager-base';
import { createFormatter, isNumberKey } from './currency-field-utilities.js';
import { CurrencyFieldInputEvent } from './CurrencyFieldEvent.js';
import { canonicalName, currencyFieldManagerConfigDefaults } from './types.js';
export class CurrencyFieldManager extends MaskedFieldManagerBase {
    constructor(field, config = currencyFieldManagerConfigDefaults) {
        const input = field.querySelector('input');
        super(input, {
            ...currencyFieldManagerConfigDefaults,
            ...config
        });
        this._handleBlur = () => {
            const value = this._maskValue(this._input.value);
            this._input.value = value;
        };
        this._validateConfig(this._config);
        this.formatter = createFormatter(this._config);
    }
    _dispatchMaskedFieldInputEvent() {
        const event = new CurrencyFieldInputEvent(this._getValidityState(), this.maskedValue, this.unmaskedValue, this._input);
        this.dispatchEvent(event);
    }
    _validateConfig(config) {
        if (config.minimumDecimalPrecision > config.maximumFractionDigits) {
            console.error(`fs-${canonicalName}: minimumDecimalPrecision value (${config.minimumDecimalPrecision}) is larger than maximumFractionDigits value (${config.maximumFractionDigits})`);
        }
        if (config.min > config.max) {
            console.error(`fs-${canonicalName}: min (${config.minimumDecimalPrecision}) is larger than max value (${config.maximumFractionDigits})`);
        }
    }
    _getValueAsNumber() {
        return +this.unmaskedValue;
    }
    _getValidityState() {
        const customValidity = this._getInitialValidityStateForInput();
        const valueAsNumber = this._getValueAsNumber();
        if (this._config.max && valueAsNumber > this._config.max) {
            customValidity.rangeOverflow = true;
            customValidity.valid = false;
        }
        if (this._config.min && valueAsNumber < this._config.min) {
            customValidity.rangeUnderflow = true;
            customValidity.valid = false;
        }
        customValidity.valid = Object.values(customValidity).every((isInvalid) => isInvalid === false);
        return customValidity;
    }
    _isKeydownAllowed(event) {
        return (super._isKeydownAllowed(event) ||
            isNumberKey(event) ||
            event.key === this._config.thousandsSeparator ||
            event.key === this._config.decimalSeparator ||
            event.key === this._config.currencySign);
    }
    _maskValue(unmaskedValue) {
        return this.formatter(unmaskedValue);
    }
    _unmaskValue(maskedValue) {
        return this.formatter(maskedValue)
            .replace(this._config.currencySign, '')
            .replace(new RegExp(this._config.thousandsSeparator, 'g'), '')
            .replace(this._config.decimalSeparator, '.');
    }
    setValue(value) {
        this._input.value = this.formatter(value);
    }
    updateConfig(updatedConfig) {
        this._config = {
            ...this._config,
            ...updatedConfig
        };
        this._validateConfig(this._config);
        this.formatter = createFormatter(this._config);
        if (this.unmaskedValue) {
            this._input.value = this.maskedValue;
        }
    }
}
//# sourceMappingURL=CurrencyFieldManager.js.map